import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

export const dropZone = {
  components: {
    dropZone: vue2Dropzone,
  },
  data() {
    return {
      dropzoneOptions: {
        url: process.env.VUE_APP_API_BASE_URL + "Admin/File",
        headers: {
          'Authorization': 'Bearer ' + localStorage.token
        },
        acceptedFiles: "image/*,application/pdf,application/txt,.zip,.docx,.xlsx,.mp3,.wav,.mp4,.mov,.gif",
        capture: true,
        parallelUploads: 2,
        maxFiles: 1,
        clickable: true,
        ignoreHiddenFiles: true,
        autoProcessQueue: true,
        uploadMultiple: true,
        thumbnailWidth: 200,
        thumbnailHeight: 200,
        thumbnailMethod: "crop",
        addRemoveLinks: true,
        maxFilesize: 80, //mb
        resizeWidth: null,
        resizeHeight: null,
        resizeQuality: 0.9,
        resizeMethod: "contain", //contain or crop
        dictDefaultMessage:
          "<p class='fs-normal fa-text'><img src='/img/static/cloud-dropzone.png' width='30px' class='ms-2'/> کلیک و یا فایل را اینجا رها کنید </p>",
      },
      dropzoneImageOptions: {
        url: process.env.VUE_APP_API_BASE_URL + "Admin/File",
        headers: {
          'Authorization': 'Bearer ' + localStorage.token
        },
        acceptedFiles: ".jpg,.png",
        capture: true,
        parallelUploads: 2,
        maxFiles: 1,
        clickable: true,
        ignoreHiddenFiles: true,
        autoProcessQueue: true,
        uploadMultiple: true,
        thumbnailWidth: 200,
        thumbnailHeight: 200,
        thumbnailMethod: "crop",
        addRemoveLinks: true,
        maxFilesize: 1, //mb
        resizeWidth: null,
        resizeHeight: null,
        resizeQuality: 0.9,
        resizeMethod: "contain", //contain or crop
        dictDefaultMessage:
          "<p class=\"mb-2 fa-text fs-medium fw-bold\">آپلود تصویر</p><p class='fs-normal mb-1 fa-text'><img src='/img/static/cloud-dropzone.png' width='30px' class='ms-2'/> کلیک و یا فایل را اینجا رها کنید </p><small class=\"mb-2 fs-smal fa-text\">فرمت jpg و png و حداکثر 1 مگابایت</small>",
      },
      dropzoneVideoOptions: {
        url: process.env.VUE_APP_API_BASE_URL + "Admin/File",
        headers: {
          'Authorization': 'Bearer ' + localStorage.token
        },
        acceptedFiles: ".mp4,.mkv",
        capture: true,
        parallelUploads: 2,
        maxFiles: 1,
        clickable: true,
        ignoreHiddenFiles: true,
        autoProcessQueue: true,
        uploadMultiple: true,
        thumbnailWidth: 200,
        thumbnailHeight: 200,
        thumbnailMethod: "crop",
        addRemoveLinks: true,
        maxFilesize: 50, //mb
        resizeWidth: null,
        resizeHeight: null,
        resizeQuality: 0.9,
        resizeMethod: "contain", //contain or crop
        dictDefaultMessage:
          "<p class='fs-normal fa-text'><img src='/img/static/cloud-dropzone.png' width='30px' class='ms-2'/> کلیک و یا فایل را اینجا رها کنید </p>",
      },
      dropzoneFileOptions: {
        url: process.env.VUE_APP_API_BASE_URL + "Admin/File",
        headers: {
          'Authorization': 'Bearer ' + localStorage.token
        },
        acceptedFiles: ".pdf,.txt,.zip,.docx,.xlsx",
        capture: true,
        parallelUploads: 2,
        maxFiles: 1,
        clickable: true,
        ignoreHiddenFiles: true,
        autoProcessQueue: true,
        uploadMultiple: true,
        thumbnailWidth: 200,
        thumbnailHeight: 200,
        thumbnailMethod: "crop",
        addRemoveLinks: true,
        maxFilesize: 10, //mb
        resizeWidth: null,
        resizeHeight: null,
        resizeQuality: 0.9,
        resizeMethod: "contain", //contain or crop
        dictDefaultMessage:
          "<p class='fs-normal fa-text'><img src='/img/static/cloud-dropzone.png' width='30px' class='ms-2'/> کلیک و یا فایل را اینجا رها کنید </p>",
      },
      dropzoneSoundOptions: {
        url: process.env.VUE_APP_API_BASE_URL + "Admin/File",
        headers: {
          'Authorization': 'Bearer ' + localStorage.token
        },
        acceptedFiles: ".mp3,.wav",
        capture: true,
        parallelUploads: 2,
        maxFiles: 1,
        clickable: true,
        ignoreHiddenFiles: true,
        autoProcessQueue: true,
        uploadMultiple: true,
        thumbnailWidth: 200,
        thumbnailHeight: 200,
        thumbnailMethod: "crop",
        addRemoveLinks: true,
        maxFilesize: 20, //mb
        resizeWidth: null,
        resizeHeight: null,
        resizeQuality: 0.9,
        resizeMethod: "contain", //contain or crop
        dictDefaultMessage:
          "<p class='fs-normal fa-text'><img src='/img/static/cloud-dropzone.png' width='30px' class='ms-2'/> کلیک و یا فایل را اینجا رها کنید </p>",
      },
      dropzoneMultipleOptions: {
        url: process.env.VUE_APP_API_BASE_URL + "Admin/File",
        headers: {
          'Authorization': 'Bearer ' + localStorage.token
        },
        acceptedFiles: ".jpg,.png",
        capture: true,
        parallelUploads: 10,
        maxFiles: 100,
        clickable: true,
        ignoreHiddenFiles: true,
        autoProcessQueue: true,
        uploadMultiple: true,
        thumbnailWidth: 200,
        thumbnailHeight: 200,
        thumbnailMethod: "crop",
        addRemoveLinks: true,
        maxFilesize: 1, //mb
        resizeWidth: null,
        resizeHeight: null,
        resizeQuality: 0.9,
        resizeMethod: "contain", //contain or crop
        dictDefaultMessage:
          "<p class='fs-normal fa-text'><img src='/img/static/cloud-dropzone.png' width='30px' class='ms-2'/> کلیک و یا فایل را اینجا رها کنید </p>",
      },
    };
  },
  methods: {
    dropZoneError() {
      this.$store.commit(
        "setError",
        "حجم و یا پسوند فایل مدنظر غیرمجاز می‌باشد"
      );
    },
    dropZoneMaxError() {
      this.$store.commit(
        "setError",
        "تعداد موارد انتخابی بیشتر از حد مجاز است"
      );
    },
  },
};
